module.exports = __webpack_public_path__ + "static/media/live-carousel-mobile-tl.9356149b.png";